export const iconFontAwesomeUsersPeopleUserLarge = (
	<i className="fa-solid fa-user-large"></i>
);
